import { render, staticRenderFns } from "./TribuneDialog.vue?vue&type=template&id=8bbc1ea8&"
import script from "./TribuneDialog.vue?vue&type=script&lang=js&"
export * from "./TribuneDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports